<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-01-28 11:01:06
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-02-19 09:40:34
-->
<template>
  <div class="PasswordLogin">
    <Form
      :model="form"
      :rules="rules"
      v-model="regular"
    >
      <Input
        label=""
        class="temr"
        v-model="form.phone"
        :reg="rules.phone"
        :maxlength="13"
        :separate="true"
        :readonly="isLock"
        labelWidth="90px"
        type="tel"
        placeholder="请输入手机号"
      />
      <div class="passwordBox">
        <Input
          label=""
          class="temr"
          v-model="form.password"
          :reg="rules.password"
          :maxlength="12"
          :type="type"
          labelWidth="90px"
          placeholder="请输入密码"
        />
        <div
          @click="showPassword"
          class="showPassword"
        >
          <img
            :src="showPicImg"
            alt=""
          />
        </div>
      </div>
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="登录"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />
  </div>
</template>

<script>
import { rules } from '@/utils';
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import JSencrypt from '@/utils/rsa/jsencrypt';
import hidePassword from '@/assets/images/hide.png';
import showPassword from '@/assets/images/show.png';

export default {
  name: 'PasswordLogin',
  data() {
    return {
      type: 'password',
      showPicImg: hidePassword,
      form: {
        phone: '',
        password: '',
      },
      rules: {
        phone: rules.legalPhone,
        password: rules.password,
      },
      loading: false,
      regular: false,
      contractList: [
        {
          text: '平台注册服务协议',
          value: 'REGISTERAGREEMENT',
        },
      ],
      isAgree: true,
    };
  },
  components: {
    Form,
    Input,
    Button,
  },
  props: ['mobile', 'isLock'],
  watch: {
    mobile: {
      handler(val) {
        this.form = {
          ...this.form,
          phone: val,
        };
      },
      immediate: true,
    },
    'form.phone': {
      handler(val) {
        if (!val) return;
        this.$emit('getCachePhone', val.replace(/\s+/g, ''));
      },
    },
  },
  methods: {
    nextStep() {
      const obj = JSON.parse(JSON.stringify(this.form));
      obj.phone = obj.phone.replace(/\s+/g, '');
      console.log(obj);
      const encrypt = new JSencrypt();
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      obj.phone = encrypt.encrypt(obj.phone);
      obj.password = encrypt.encrypt(obj.password);
      obj.foreignOrderId = this.$route.query.foreignOrderId;
      this.$emit('login', obj);
    },
    showPassword() {
      this.type = this.type === 'password' ? 'text' : 'password';
      // eslint-disable-next-line no-unused-expressions
      this.type === 'password'
        ? (this.showPicImg = hidePassword)
        : (this.showPicImg = showPassword);
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 16px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.passwordBox {
  position: relative;
}
.showPassword {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 17px;
  right: 18px;
  background: #fff;
}
.showPassword img {
  width: 100%;
  height: 100%;
}
.PasswordLogin >>> .passwordBox input {
  width: 100% !important;
}
.PasswordLogin >>> .Input {
  padding: 16px;
}
.PasswordLogin >>> .Input input {
  font-size: 15px !important;
}
.Contract {
  margin-top: 12px;
}
</style>
